<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex">
                <h1>Sovereign Green Bond</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li class="active"><a routerLink="/sovereignGreenBond/sgrb" skipLocationChange>Dashboard</a></li>

                </ul>
            </div>
        </div>
    </div>
    <div id="accordion" class="mb-1">
        <div class="card">
            <div class="card-header pointer" id="memberheading">
                <h3 data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
                    aria-controls="collapseFilter">
                    <i class="fa fa-angle-down pull-right customIcon mr-2"></i>Advanced Search
                </h3>
            </div>
            <div id="collapseFilter" class="collapse show" aria-labelledby="memberheading" data-parent="#accordion">
                <div class="card card-body">
                    <form [formGroup]='searchForm'>
                        <div class="row">
                            <div class="col-lg-3 form-group">
                                <label>Reporting Member</label>
                                <input type="text" formControlName="reportingMemId"  class="form-control form-control-sm">
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Counter Party</label>
                                <select class="form-control form-control-sm selectpicker"
                                    formControlName="countrPartyId" title="Select Counter Party"
                                    data-live-search="true">
                                    <option value="" disabled>Select Counter Party</option>
                                    <option *ngFor="let data of entityCodeArray" value="{{data.entityCode}}">
                                        {{data.entityCode +" - "+data.userName}}</option>
                                </select>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Trade Date<span class="red">*</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm datepicker date"
                                        [(bsValue)]="bsValue[0]" formControlName="trdDate"
                                        bsDaterangepicker [bsConfig]="{ isAnimated: true}" placeholder="Select Trade Date">
                                    <div class="input-group-append pointer">
                                        <span class="input-group-text">
                                            <i class="fa fa-calendar" [(bsValue)]="bsValue[0]" bsDaterangepicker
                                                 [bsConfig]="{ isAnimated: true }"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 form-group">
                                <label>Deal Status</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="dealStatus"
                                    title="Select Swap Type">
                                    <option value="" disabled>Select Deal Type</option>
                                    <option *ngFor="let data of dealStatus" value="{{data}}">{{data}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-lg-1 form-group">
                                <button class="btn btn-primary full-width" (click)="getFilteredDeal()"> Search</button>
                            </div>
                            <div class="col-lg-1 form-group">
                                <button class="btn btn-secondary full-width" (click)="reset()"> Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="card card-body colorborder">
        
        <div class="col-lg-12">
            <div class="col-auto mt-2 mb-1 float-right">
                <button class="btn btn-cancel mt-1 " (click)="newDeal()"><i class="fa fa-plus" aria-hidden="true"></i>
                    New Order</button>
            </div>
            <div class="table-responsive">
                <table id="trdTbl" class="table common-table nowrap" datatable [dtOptions]="dtOptions"
                    [dtTrigger]="dtTrigger">
                    <thead>
                        <tr>
                            <th class="normalwrap">Reference Number</th>
                            <th class="normalwrap">Trade Number</th>
                            <th class="normalwrap">Reporting Member ID</th>
                            <th class="normalwrap">Counter Party Id</th>
                            <th class="normalwrap">Order Price</th>
                            <th class="normalwrap">Quantity</th>
                            <th class="normalwrap">Trade Value</th>
                            <th class="normalwrap">Trade Date & Time</th>
                            <th class="normalwrap">Settlement Date</th>
                            <th class="normalwrap">Status</th>
                            <th class="normalwrap">Action</th>

                        </tr>
                        <tr class="column-search">
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th><input type="text" class="form-control form-control-sm" /></th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr [ngClass]="{'rejected':data.processingSatus=='R' && data.dealStatus=='Rejected' ,
                        'approved':data.processingSatus=='A',}" *ngFor="let data of  tradeData;let i=index">
                            <td>{{data.orderId}}</td>
                            <td>{{data.tradeNumber}}</td>
                            <td>{{data.reportingMemId}}</td>
                            <td>{{data.countrPartyId}}</td>
                            <td>{{data.orderPrice}}</td>
                            <td>{{data.qty}}</td>
                            <td>{{data.trdValue}}</td>
                            <td>{{data.trdDate | date:'dd-MMM-yyyy'}} {{data.trdTime|date:'HH:mm:ss'}}</td>
                            <td>{{data.settlementDate | date:'dd-MMM-yyyy'}}</td>
                            <td>{{data.dealStatus}}</td>
                            <td> <i class="fa fa-pencil" (click) = "redirectToDeal(data.orderId)"></i> </td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="cancelTrade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header card-header">
                <h5 class="modal-title ">Reject Deal</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to Reject deal ?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="onCloseModal()">Close</button>

                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="cancelDeal()">
                    Confirm </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="approveTrade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header card-header">
                <h5 class="modal-title ">Approve Deal</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to Approve deal ?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="onCloseModal()">Close</button>

                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="approveDeal()">
                    Confirm </button>
            </div>
        </div>
    </div>
</div>